































import {
  defineComponent,
} from '@vue/composition-api';
import useAuth from '@/useAuth';

const List = defineComponent({
  setup() {
    const { me, hasPermission } = useAuth();

    return {
      me,
      hasPermission,
      openToS: () => { window.open('/#/terms-of-service'); },
    };
  },
});

export default List;
